module.exports = __webpack_public_path__ + "static/media/6.bebd5270.jpg";